import { useState } from "react";
import axios from "axios";
import { storage } from "../utils/storage";
import { UserData } from "../types/user";
const baseUrl = process.env.REACT_APP_API_CONFIG;

interface VerifyOtpResponse {
  jwt: string;
  user: UserData;
}

export default function useVerifyOtp() {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [userData, setUserData] = useState<VerifyOtpResponse | null>(null);

  const verifyOtp = async ({
    email,
    code,
    otpId,
  }: {
    email: string;
    code: string;
    otpId: string;
  }) => {
    setLoading(true);
    setError(null);

    try {
      console.log("Verifying OTP:", { email, code, otpId });
      const response = await axios.post<{ data: VerifyOtpResponse }>(
        `${baseUrl}/auth/verify-otp`,
        { email, code, otp_id: otpId }
      );

      console.log("OTP Verification Success:", response.data);

      const { jwt, user } = response.data.data;
      const refreshToken = (response.data.data as any).refresh_token;

      storage.setJwtToken(jwt);
      if (refreshToken) storage.setRefreshToken(refreshToken);
      storage.setUserEmail(user.email);
      storage.setUserData(user);

      setUserData(response.data.data);
    } catch (err) {
      console.error("Failed to verify OTP:", err);
      setError("Invalid OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return { verifyOtp, userData, loading, error };
}
